module.exports = __webpack_public_path__ + "static/img/0547_4.2bc7202.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0547_4.jpg
// module id = DbZM
// module chunks = 1